export default "__VITE_ASSET__wfTf2fFu__"